import React from 'react';
import classNames from 'classnames';
import { List } from 'immutable';

import { Paragraph, View, Block } from '@uncinc/react-drupal-core';
import { Container, WysiwygField, Button } from '@uncinc/uncinc-react-kitchen-sink';

import QuickLinks from '../../../components/QuickLinks';
import { BLOCK_NEWSLETTER_BLOCK_ID } from '../../../config/constants';
import VariableRatiosPicture from '../../../components/VariableRatiosPicture';

import './style.scss';

const NodeHomepage = ({ entity, className }) => {
  const classes = classNames(className, 'NodeHomepage');
  const node = entity.toJS();
  const heroTitle = node.title[0].value;
  const media = node.field_media_item[0];
  const link = node.field_link[0]?.title;
  const heroBody = node.body[0]?.processed;
  const linkSecondary = node.field_link[1]?.title;
  const linkUri = node.field_link[0]?.alias || node.field_link[0]?.uri;
  const linkSecondaryUri = node.field_link[1]?.alias || node.field_link[1]?.uri;

  const quickLinks = node.field_quick_links_links;
  const quickLinksTitle = node.field_quick_links_title[0]?.value;

  return (
    <>
      <article itemType="http://schema.org/WebPage" className={classes}>

        <div className="NodeHomepage__hero">
          <div className="NodeHomepage__hero__image">
            <VariableRatiosPicture
              image={media}
              aspectRatios={['2_1', '2_1', '3_1', '3_1', '4_1']}
            />
          </div>

          <div className="NodeHomepage__hero__wrapper">
            <Container>
              <div className="row">
                <div className="NodeHomepage__hero__bar col-12 col-md-6 col-lg-7 col-xl-8">
                  <div className="rectangle-left" />
                  <div className="rectangle" />
                  <div className="triangle--homepage" />
                </div>
              </div>
            </Container>
            <Container>
              <div className="row">
                <div className="col-md-6 col-lg-7">
                  <div className="NodeHomepage__hero__text">
                    <h1 className="NodeHomepage__hero__title" itemProp="name">{heroTitle}</h1>
                    {heroBody && (
                      <WysiwygField
                        property="schema:text"
                        className="NodeHomepage__hero__body"
                        html={heroBody}
                      />
                    )}
                    <div className="NodeHomepage__hero__links">
                      {link &&
                        <Button
                          href={linkUri}
                          className="Button Button--primary icon-after icon-arrow-right icon-variant-1">
                          {link}
                        </Button>}

                      {linkSecondary &&
                        <Button
                          href={linkSecondaryUri}
                          className="Button Button--secondary icon-after icon-arrow-right icon-variant-2">
                          {linkSecondary}
                        </Button>}
                    </div>
                  </div>
                </div>

                {quickLinks.length > 0 &&
                  <div className="col-md-6 col-lg-4 offset-lg-1">
                    <QuickLinks title={quickLinksTitle} links={quickLinks} />
                  </div>}

              </div>
            </Container>
          </div>
        </div>

        {entity.get('field_paragraphs') ? (
          <div className="NodeHomepage__paragraphs">
            {entity.get('field_paragraphs', List()).map((paragraph) => {
              const id = paragraph.get('target_id');
              const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);

              return (
                <Paragraph
                  key={`paragraph:${id}:${language}`}
                  entity={paragraph.get('entity')}
                />
              );
            })}
          </div>
        ) : null}

      </article>

      {/* Newsletter block */}
      <Block
        id={BLOCK_NEWSLETTER_BLOCK_ID}
      />

      {/* Partners slider */}
      <View
        id="partners"
        display="slider"
      />

    </>
  );
};

export default NodeHomepage;
